function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(arg) { var key = _toPrimitive(arg, "string"); return _typeof(key) === "symbol" ? key : String(key); }
function _toPrimitive(input, hint) { if (_typeof(input) !== "object" || input === null) return input; var prim = input[Symbol.toPrimitive]; if (prim !== undefined) { var res = prim.call(input, hint || "default"); if (_typeof(res) !== "object") return res; throw new TypeError("@@toPrimitive must return a primitive value."); } return (hint === "string" ? String : Number)(input); }
function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }
function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }
function _iterableToArrayLimit(arr, i) { var _i = null == arr ? null : "undefined" != typeof Symbol && arr[Symbol.iterator] || arr["@@iterator"]; if (null != _i) { var _s, _e, _x, _r, _arr = [], _n = !0, _d = !1; try { if (_x = (_i = _i.call(arr)).next, 0 === i) { if (Object(_i) !== _i) return; _n = !1; } else for (; !(_n = (_s = _x.call(_i)).done) && (_arr.push(_s.value), _arr.length !== i); _n = !0) { ; } } catch (err) { _d = !0, _e = err; } finally { try { if (!_n && null != _i.return && (_r = _i.return(), Object(_r) !== _r)) return; } finally { if (_d) throw _e; } } return _arr; } }
function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }
import React, { useEffect, useState } from "react";
import isArray from "lodash/isArray";
import isNumber from "lodash/isNumber";
import classNames from "classnames";
import parseTNode from "../../utils/parseTNode";
import { toCSSLength } from "../../utils/to-css-length";
var ThemeMap = {
  avatar: [{
    type: "circle",
    size: "48px"
  }],
  image: [{
    type: "rect",
    size: "72px"
  }],
  text: [[{
    width: "24%",
    height: "16px",
    marginRight: "16px"
  }, {
    width: "76%",
    height: "16px"
  }], 1],
  paragraph: [1, 1, 1, {
    width: "55%"
  }]
};
var classPrefix = "tc-skeleton";
var Skeleton = function Skeleton(props) {
  var className = props.className,
    style = props.style,
    animation = props.animation,
    _props$delay = props.delay,
    delay = _props$delay === void 0 ? 0 : _props$delay,
    loading = props.loading,
    rowCol = props.rowCol,
    children = props.children;
  var _useState = useState(loading),
    _useState2 = _slicedToArray(_useState, 2),
    isLoading = _useState2[0],
    setIsLoading = _useState2[1];
  var renderCols = function renderCols(_cols) {
    var cols = [];
    if (isArray(_cols)) {
      cols = _cols;
    } else if (isNumber(_cols)) {
      cols = new Array(_cols).fill({
        type: "text"
      });
    } else {
      cols = [_cols];
    }
    var getColItemClass = function getColItemClass(obj) {
      return classNames("".concat(classPrefix, "__col"), "".concat(classPrefix, "--type-").concat(obj.type || "text"), _defineProperty({}, "".concat(classPrefix, "--animation-").concat(animation), animation));
    };
    var getColItemStyle = function getColItemStyle(obj) {
      var styleName = ["width", "height", "marginRight", "marginLeft", "margin", "size", "background", "backgroundColor", "borderRadius"];
      var styles = {};
      styleName.forEach(function (name) {
        if (name in obj) {
          var px = toCSSLength(obj[name]);
          if (name === "size") {
            var _ref = [px, px];
            styles.width = _ref[0];
            styles.height = _ref[1];
          } else {
            styles[name] = px;
          }
        }
      });
      return styles;
    };
    return cols.map(function (obj, index) {
      return (
        /*#__PURE__*/
        // eslint-disable-next-line react/no-array-index-key
        React.createElement("div", {
          key: index,
          className: getColItemClass(obj),
          style: getColItemStyle(obj)
        }, parseTNode(obj.content))
      );
    });
  };
  var renderRowCol = function renderRowCol(_rowCol) {
    var renderedRowCol = _rowCol || rowCol;
    return renderedRowCol.map(function (item, index) {
      return (
        /*#__PURE__*/
        // eslint-disable-next-line react/no-array-index-key
        React.createElement("div", {
          key: index,
          className: "".concat(classPrefix, "__row")
        }, renderCols(item))
      );
    });
  };
  useEffect(function () {
    if (delay > 0 && !loading) {
      var timeout = setTimeout(function () {
        setIsLoading(loading);
      }, delay);
      return function () {
        return clearTimeout(timeout);
      };
    }
    setIsLoading(loading);
  }, [delay, loading]);
  if (!isLoading) {
    return /*#__PURE__*/React.createElement(React.Fragment, null, parseTNode(children));
  }
  var childrenContent = [];
  // 保持优先级： rowCol > theme，增加默认值兜底
  if (rowCol) {
    childrenContent.push(renderRowCol(rowCol));
  } else if (props.theme) {
    childrenContent.push(renderRowCol(ThemeMap[props.theme]));
  } else if (!props.theme && !rowCol) {
    // 什么都不传时，传入默认 rowCol
    childrenContent.push(renderRowCol([[{
      width: "24%",
      height: "16px",
      marginRight: "16px"
    }, {
      width: "76%",
      height: "16px"
    }], 1]));
  }
  return /*#__PURE__*/React.createElement("div", {
    className: classNames("".concat(classPrefix), className),
    style: style
  }, childrenContent);
};
Skeleton.defaultProps = {
  animation: "none",
  delay: 0,
  loading: true
};
export default Skeleton;